module.exports = __webpack_public_path__ + "img/coins2.50d68c9b.png";